var _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipseLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 498,
    viewBox: "0 0 333 498",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.6961,
    cy: 227.057,
    r: 148.028,
    transform: "rotate(138.21 60.6961 227.057)",
    stroke: "#168004",
    strokeWidth: 0.551994
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71.4177,
    cy: 239.052,
    r: 148.028,
    transform: "rotate(138.21 71.4177 239.052)",
    stroke: "#168004",
    strokeWidth: 0.551994
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseLeft);
export default __webpack_public_path__ + "static/media/ellipse-left.475682407ea7a045fc3260ea2a7afebe.svg";
export { ForwardRef as ReactComponent };